module.exports = "/img/identification.png?f5fb6d096fc79efb03ff8889990f64f4";